import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { AttachmentInfoService } from './attachment-info.service';
import { DialogService } from '../../../../../../../shared/services/dialog.service';
import { AppMessages } from '../../../../../../../shared/constants/messages';
import { Utility } from '../../../../../../../common/utility';

@Component({
  selector: 'app-attachment-info',
  templateUrl: './attachment-info.component.html',
  providers: [AttachmentInfoService]
})
export class AttachmentInfoComponent implements OnInit, OnChanges {
  @Input() groupId: string;
  @Input() height: number;
  attachments = [];
  attachmentFile = null;
  @Input() isLoadedTab: boolean;
  constructor(public utility: Utility, public dialogService: DialogService, private attachmentService: AttachmentInfoService) { }

  ngOnChanges() {
    if (this.isLoadedTab) {
      this.getAttachments();
    }
  }
  ngOnInit() {

  }

  getAttachments() {
    this.attachmentService.getAttachments(this.groupId).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.attachments = data;
        }
      }
    );
  }
  uploadAttachment() {
    if (this.attachmentFile) {
      const formData = new FormData();
      formData.append('uploadFile', this.attachmentFile, this.attachmentFile.name);
      this.attachmentService.saveAttachment(this.groupId, formData).subscribe(result => {
        if (result) {
          this.attachmentFile = null;
          this.getAttachments();
        }
      }
      );
    }
  }

  removeAttachment(id: string) {
    this.dialogService.openConfirmationDialog({ message: AppMessages.groupTemplateConsultant.removeAttachment }).subscribe(result => {
      if (result) {
        this.attachmentService.removeAttachment(this.groupId, id).subscribe(result => {
          if (result) {
            this.getAttachments();
          }
        }
        );
      }
    });
  }
  onChangeAttachment(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      // Show error dialog when file > 2MB
      if (this.utility.isValidFile(file, ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "jpg", "png"], 2)) {
        this.attachmentFile = file;
      } else {
        this.dialogService.openErrorDialog({ message: AppMessages.errors.invalidDocFile });
      }
    }
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group-template/group-template-information-popup/group-template-information/attachment-info/attachment-info.component.ts